Vendd.Scripts.load(function () {

    var $wrapper = $('.x-product-reviews[data-type="reviews"]'),
        model = null, literals = null, consents = null, sorting = null, isInitialCall = true,
        loadMoreReviews = false, updateSorting = false, isVerifiedBuyerChecked = false;

    if ($wrapper.length < 1) return;

    wrapper = $wrapper.get(0);

    var productId = $wrapper.data('product-id');
    var pageNumber = $wrapper.data('page-number');
    var pageSize = $wrapper.data('page-size');
    var totalPageSize = pageSize;
    var sortBy = $wrapper.data('sort-by');
    var filterBy = "";

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.reviewForm = function () {

        var $productReviewForm = $('.x-product-review-form[data-control="form"]', $wrapper);

        if ($productReviewForm.length < 1) return;

        var $openFormLink = $('.form-show-hide[data-click="open-product-review-form"]', $wrapper);
        var $closeFormLink = $('.form-show-hide[data-click="close-product-review-form"]', $productReviewForm);

        $openFormLink.click(function (e) {
            if ($openFormLink.hasClass('x-closed')) {
                $openFormLink.removeClass('x-closed').addClass('x-opened');
                $closeFormLink.removeClass('x-closed').addClass('x-opened');
                $productReviewForm.removeClass('x-collapsed').removeClass('x-closed').addClass('x-opened');
                $productReviewForm.show();
            }
        });

        $closeFormLink.click(function (e) {
            if ($closeFormLink.hasClass('x-opened')) {
                $openFormLink.removeClass('x-opened').addClass('x-closed');
                $closeFormLink.removeClass('x-opened').addClass('x-closed');
                $productReviewForm.removeClass('x-opened').addClass('x-closed');
                $productReviewForm.hide();
            }
        });
    };

    wrapper.loginPopup = function () {

        var $loginPopup = $('div[data-type="review-login-popup"]', $wrapper);

        if ($loginPopup.length < 1) return;

        if (!model.Authenticated) {

            var $showLoginMessageLink = $('*[data-click="show-login-message"]', $wrapper);

            $showLoginMessageLink.click(function (e) {
                $loginPopup.show();
            });

            var $loginLink = $('*[data-click="login"]', $loginPopup);
            var $registerLink = $('*[data-click="register"]', $loginPopup);
            var $closeBtn = $('*[data-click="close-popup"]', $loginPopup);

            var $loginWidget = $('.x-control.x-widget.x-login-widget').first();
            var redirectUrl = LhApp.Function.Url.setParameterValue('mode', 'add-review');

            $loginLink.click(function (e) {
                $loginPopup.hide();

                var $loginForm = $('.x-login-form .login-form', $loginWidget);
                $loginForm.attr('data-redirect', redirectUrl);

                $('.js-widget-trigger', $loginWidget).trigger('click');
            });

            $registerLink.click(function (e) {
                document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Register, 'ReturnUrl', encodeURIComponent(redirectUrl));
            });

            $closeBtn.click(function (e) {
                $loginPopup.hide();
            });

        } else {
            $loginPopup.remove();
        }
    };

    wrapper.pager = function () {

        var $scrollPager = $('.scrolllist-pager-notification', $wrapper);

        if ($scrollPager.length < 1) return;

        if (model.ReviewsCount > pageSize) {
            $scrollPager.removeClass('hidden');
        }

        $scrollPager.on('click', '.js-show', function () {
            wrapper.loading(true);

            loadMoreReviews = true;
            pageNumber = pageNumber + 1;
            totalPageSize = totalPageSize + pageSize;
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetReviews(productId, pageNumber, pageSize, sortBy, isInitialCall, filterBy));
        });
    };

    wrapper.loadMoreReviews = function () {

        var html = Vendd.Handlebars.parse("pdReview_A", model);

        var $html = $(html),
            $container = $('.x-product-review-list', $wrapper),
            $list = $('.x-product-review-list ul.review-list', $wrapper),
            $boxes = $('.x-product-review-box', $html),
            lastItem = $list.children().last();

        //get new reviews
        var items = wrapBoxes($boxes, lastItem, model);

        //append new reviews in list
        $list.append(items);

        //manipulate scroll pager
        if (totalPageSize >= model.ReviewsCount)
            $('.scrolllist-pager-notification', $wrapper).addClass('hidden');

         //bind controls
        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

        wrapper.loading(false);
    };

    wrapper.update = function () {

        var html = Vendd.Handlebars.parse("pdReview_A", model);

        $wrapper.html(html);

        wrapper.reviewForm();

        wrapper.loginPopup();

        wrapper.pager();

        if (updateSorting) {
            updateSorting = false;
            wrapper.scrollToTop();        
        }

        //bind controls
        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

        wrapper.loading(false);
    };

    wrapper.updateSorting = function (sorting) {
        wrapper.loading(true);

        updateSorting = true;
        pageNumber = 1;
        totalPageSize = pageSize;
        sortBy = sorting;

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetReviews(productId, pageNumber, pageSize, sortBy, isInitialCall, filterBy));
    };

    wrapper.scrollToTop = function () {
        var scrollOffset = $(window).outerWidth() > 960 ? 100 : 50;
        $('html, body').animate({ scrollTop: $('.product-details-region .x-pd-tab-panel .tab-content.reviews').offset().top - scrollOffset }, 100);
    };

    $wrapper.on('click', '*[data-click="order-by-latest"]', function (e) {
        wrapper.updateSorting("latest");
    });

    $wrapper.on('click', '*[data-click="order-by-helpfullness"]', function (e) {
        wrapper.updateSorting("helpfullness");
    });

    $wrapper.on('click', '*[data-click="order-by-verified-buyer"]', function (e) {
        wrapper.updateSorting("verifiedbuyer");
    });

    $wrapper.on('change', 'input[name="verifiedBuyer"]', function (e) {
        var $this = $(this);

        if ($this.is(":checked")) {
            isVerifiedBuyerChecked = true;
            filterBy = "verifiedbuyer";
        } else {
            isVerifiedBuyerChecked = false;
            filterBy = "";
        }

        wrapper.updateSorting(sortBy);
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetReviews(productId, pageNumber, pageSize, sortBy, isInitialCall, filterBy));

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetReviewsSuccess, wrapper, function (envelope) {
        model = envelope.message.data.Data;

        //add product id in model
        model.Id = productId;
        //add parameter in stars model
        if (model.Authenticated && !model.ReviewdByCurrentUser) {
            model.Stars.Enabled = true;
        } else {
            model.Stars.Enabled = false;
        }
        //add filter verified buyer in model
        model.IsVerifiedBuyerChecked = isVerifiedBuyerChecked;

        //get literals, consents and sorting options
        if (isInitialCall) {
            isInitialCall = false;
            consents = { Consents: envelope.message.data.Data.Consents };
            sorting = { SortingOptions: envelope.message.data.Data.SortingOptions };
            literals = envelope.message.data.Text;
        } else {
            //extend model with consents
            model = { ...model, ...consents };
            //extend model with sorting options
            model = { ...model, ...sorting };
        }

        //extend model with literals
        model = { ...model, ...literals };

        //update
        if (loadMoreReviews) {
            loadMoreReviews = false;
            wrapper.loadMoreReviews();
        } else {
            wrapper.update();
        } 
    });

    function wrapBoxes($boxes, lastItem, model) {
        var items = [], currentIndex, cssClass;

        lastItem.removeClass('last');

        currentIndex = lastItem.data('index') + 1;

        for (var i = 0; i < $boxes.length; i++) {
            var li = $('<li>');

            cssClass = "item" + currentIndex + " " + "review-item";
            cssClass += (i === $boxes.length - 1) ? " last" : "";

            li.append($boxes.eq(i))
                .addClass(cssClass)
                .attr('data-index', currentIndex)
                .attr('data-page', pageNumber);

            items.push(li);

            currentIndex++;
        }

        return items;
    };

});